import type { FaireProductEntity } from "../../entity_types/product";

export const p_vs4xr7yk36: FaireProductEntity = {
  token: "p_vs4xr7yk36",
  type: "product",
  name: "Lumiere 18K Gold Cross Necklace with Beads and Pearls",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl:
    "https://cdn.faire.com/fastly/18a79b4224e09c91778f23f5037acfe24991ca45bf5faeddf5a6eb911871f3b1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5814d2b4762e03226cb705b956fb5f5397d378932d2bb7b6f3bdd7c4954356f3.jpeg",
    "https://cdn.faire.com/fastly/9d0c800c7e35182513db180a9df8175dd0b7e09aacd3ae887fd043fd91106945.jpeg",
    "https://cdn.faire.com/fastly/f72b38a90ca8415402832efb30521060dc37ae0a751fd17898e5f2634fe8b7cb.jpeg",
  ],
  priceDollars: 9.67,
  description:
    "18K Gold-Plated Cross Necklace with Beads and Pearls\n18K Gold Plating\nStainless Steel\nFaux Pearl\nBrown Beads\nPendant Size (inch): 0.7\nChain Length (inch): 16\nExtension Length (inch): 2\n \n- Lead-free, Nickel-safe",
  tags: [],
  msrpDollars: 33.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:37.711Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
